import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './TopBar.css';

const TopBar = ({ activeNav }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  const headerRef = useRef(null);

  // Sincronizar tema oscuro con <html>
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark-theme');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark-theme');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  const toggleTheme = (e) => {
    e.preventDefault();
    setIsDarkMode(prev => !prev);
  };

  // Scroll listener para el header sticky
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 60) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId, e) => {
    if (e) e.preventDefault();
    setIsMobileMenuOpen(false);

    if (location.pathname === '/') {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const isHome = location.pathname === '/';
  const isFilosofia = location.pathname === '/filosofia';

  return (
    <header
      id="main-header"
      ref={headerRef}
      className={`site-header ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'menu-open' : ''}`}
    >
      <div className="header-inner">
        {/* Logotipo Expansivo Suizo Minimalista */}
        <div
          className="logo-container"
          onClick={(e) => handleNavClick('hero', e)}
          role="button"
          tabIndex={0}
          title="QRT Solutions"
        >
          <span className="logo-parenthesis p-start">(</span>
          <span className="logo-word" id="word-q">
            <span className="logo-always">q</span>
            <span className="logo-collapsible">uantitative</span>
          </span>
          <span className="logo-space"></span>
          <span className="logo-word" id="word-r">
            <span className="logo-always">r</span>
            <span className="logo-collapsible">esearch</span>
          </span>
          <span className="logo-space"></span>
          <span className="logo-word" id="word-t">
            <span className="logo-always">t</span>
            <span className="logo-collapsible">rading</span>
          </span>
          <span className="logo-parenthesis p-end">)</span>
          <span className="logo-always logo-exponent">^</span>
        </div>

        <nav>
          <ul>
            <li>
              <button
                type="button"
                id="theme-toggle"
                className="theme-toggle"
                aria-label="cambiar tema"
                onClick={toggleTheme}
              >
                <svg className="theme-icon" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
                  <path d="M 12,2 A 10,10 0 0 0 12,22 Z" fill="currentColor" />
                </svg>
              </button>
            </li>
            <li className="nav-item-hide">
              <a
                href="/#hero"
                className={`nav-link ${isHome && activeNav === 'hero' ? 'active' : ''}`}
                onClick={(e) => handleNavClick('hero', e)}
              >
                inicio
              </a>
            </li>
            <li className="nav-item-hide">
              <a
                href="/#perfiles"
                className={`nav-link ${isHome && activeNav === 'perfiles' ? 'active' : ''}`}
                onClick={(e) => handleNavClick('perfiles', e)}
              >
                perfiles
              </a>
            </li>
            <li className="nav-item-hide">
              <a
                href="/#sistema"
                className={`nav-link ${isHome && activeNav === 'sistema' ? 'active' : ''}`}
                onClick={(e) => handleNavClick('sistema', e)}
              >
                sistema
              </a>
            </li>
            <li className="nav-item-hide">
              <Link
                to="/filosofia"
                className={`nav-link ${isFilosofia ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                filosofía
              </Link>
            </li>
            <li className="nav-item-hide">
              <a
                href="/#contacto"
                className={`nav-link ${isHome && activeNav === 'contacto' ? 'active' : ''}`}
                onClick={(e) => handleNavClick('contacto', e)}
              >
                contacto
              </a>
            </li>

          </ul>
        </nav>

        {/* Botón de Menú Móvil */}
        <button
          id="mobile-menu-toggle"
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          aria-label="abrir menú"
          onClick={() => setIsMobileMenuOpen(prev => !prev)}
        >
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </header>
  );
};

export default TopBar;
